import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.modal');
import { DoCheck, OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-modal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.modal/view.scss */
:host {
  display: contents;
}

.hn-modal-layer {
  inset: 0;
  position: fixed;
  z-index: 90;
}

.hn-modal-backdrop {
  backdrop-filter: blur(5px);
  background: rgba(12, 15, 12, 0.52);
  inset: 0;
  position: absolute;
}

.hn-modal-viewport {
  align-items: center;
  display: flex;
  inset: 0;
  justify-content: center;
  overflow-y: auto;
  padding: 24px;
  position: absolute;
}

.hn-modal {
  animation: hn-modal-enter 0.22s cubic-bezier(0.2, 0.8, 0.25, 1) both;
  background: var(--hn-paper, #fff);
  border: 1px solid var(--hn-line, #dfe4dc);
  border-radius: 16px;
  box-shadow: 0 30px 90px rgba(9, 12, 9, 0.26);
  max-width: 440px;
  overflow: hidden;
  width: 100%;
}

.hn-modal__content {
  display: grid;
  gap: 15px;
  grid-template-columns: 44px minmax(0, 1fr);
  padding: 25px 25px 22px;
}

.hn-modal__icon {
  align-items: center;
  background: var(--hn-accent-soft, #edf4dd);
  border-radius: 12px;
  color: var(--hn-accent-deep, #5e7727);
  display: flex;
  height: 44px;
  justify-content: center;
  width: 44px;
}

.hn-modal__icon i {
  font-size: 15px;
}

.hn-modal.is-warning .hn-modal__icon {
  background: var(--hn-warn-soft, #fff6df);
  color: var(--hn-warn, #b97916);
}

.hn-modal.is-error .hn-modal__icon {
  background: var(--hn-danger-soft, #fff0ed);
  color: var(--hn-danger, #d94c3a);
}

.hn-modal h3 {
  color: var(--hn-ink, #171a17);
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.35;
  margin: 1px 0 0;
}

.hn-modal p {
  color: var(--hn-muted, #687168);
  font-size: 14px;
  line-height: 1.6;
  margin: 7px 0 0;
  white-space: pre-wrap;
}

.hn-modal__actions {
  background: var(--hn-paper-soft, #f8faf6);
  border-top: 1px solid var(--hn-line, #dfe4dc);
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
  padding: 14px 16px;
}

.hn-modal__button {
  border-radius: 9px;
  font-size: 13px;
  font-weight: 800;
  min-height: 44px;
  padding: 0 16px;
}

.hn-modal__button--primary {
  background: var(--hn-accent, #a8c85d);
  border: 1px solid #91ad4e;
  color: var(--hn-accent-ink, #26320f);
}

.hn-modal.is-warning .hn-modal__button--primary {
  background: #bd7b19;
  border-color: #a56a12;
  color: #fff;
}

.hn-modal.is-error .hn-modal__button--primary {
  background: var(--hn-danger, #d94c3a);
  border-color: #bb392a;
  color: #fff;
}

.hn-modal__button--secondary {
  background: var(--hn-paper, #fff);
  border: 1px solid var(--hn-line-strong, #cbd2c7);
  color: var(--hn-ink, #171a17);
}

.hn-modal__button:hover:not(:disabled) {
  filter: brightness(1.04);
}

@keyframes hn-modal-enter {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 540px) {
  .hn-modal-viewport {
    align-items: flex-end;
    padding: 12px 12px calc(12px + env(safe-area-inset-bottom));
  }
  .hn-modal {
    border-radius: 17px;
  }
  .hn-modal__content {
    grid-template-columns: 40px minmax(0, 1fr);
    padding: 22px 18px 20px;
  }
  .hn-modal__icon {
    height: 40px;
    width: 40px;
  }
  .hn-modal__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .hn-modal__button {
    width: 100%;
  }
  .hn-modal__button--primary {
    grid-column: 2;
  }
  .hn-modal__button--secondary {
    grid-column: 1;
    grid-row: 1;
  }
  .hn-modal__button:only-child {
    grid-column: 1/-1;
  }
}`],
})
export class PortalSeasonModalComponent implements OnInit, DoCheck {
    @Input() model: any = null;
    private wasShown = false;
    private returnFocus: HTMLElement | null = null;

    constructor(@Inject( Service) public service: Service) {
        if (!this.model) this.model = service.modal;
    }

    public async ngOnInit() {
    }

    public ngDoCheck() {
        const isShown = !!this.model?.isshow;
        if (isShown && !this.wasShown) {
            this.returnFocus = document.activeElement as HTMLElement;
            setTimeout(() => {
                const dialog = document.getElementById('season-modal-dialog');
                const action = dialog?.querySelector('button') as HTMLElement;
                (action || dialog)?.focus();
            }, 0);
        }
        if (!isShown && this.wasShown) {
            setTimeout(() => this.returnFocus?.focus(), 0);
        }
        this.wasShown = isShown;
    }

    public handleKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            this.model.cancel();
            return;
        }
        if (event.key !== 'Tab') return;

        const dialog = document.getElementById('season-modal-dialog');
        if (!dialog) return;
        const focusable = Array.from(
            dialog.querySelectorAll<HTMLElement>('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        );
        if (!focusable.length) {
            event.preventDefault();
            dialog.focus();
            return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public btnColorClass() {
        if (this.model.opts.status == 'warning')
            return 'inline-flex min-h-11 w-full items-center justify-center rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-500 sm:ml-3 sm:w-auto';
        if (this.model.opts.status == 'success')
            return 'inline-flex min-h-11 w-full items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto';
        return 'inline-flex min-h-11 w-full items-center justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto';
    }
}

export default PortalSeasonModalComponent;